'use client';

import CompareWidget from 'components/commercetools-ui/organisms/product/product-list-algolia/components/Compare-Page';
import CompareWidgetPLP from 'components/commercetools-ui/organisms/product/product-list-algolia/components/Compare-Page-Listing';
import React, { useEffect, useState } from 'react';

const ComparePage = () => {
  const [previousUrl, setPreviousUrl] = useState<string | null>(null);

  useEffect(() => {
    const url = sessionStorage.getItem('previousUrl');
    setPreviousUrl(url);
  }, []);

  return <div>{previousUrl === '/search/' ? <CompareWidget /> : <CompareWidgetPLP />}</div>;
};

export default ComparePage;
